import {  CreditLimitRequest, CreditState, GetCreditReportsResponse, GetCreditResponse, TransactionTypes } from "Application/models";
import { addCredit, fetchCredit, fetchCreditReports } from "Application/service";
import { create } from "zustand";
import { useAgencyStore } from "./useAgencyStore";

export const useCreditStore = create<CreditState >((set) => ({
  isLoading: false,
  isDownloadFileLoading:false,
  isError: false,
  error: null,
  creditData: [],
  getCreditData: [],
  getCreditReportsData:[],


  setCredit: async (creditData: CreditLimitRequest, agencyId:number) => {
    set({ isLoading: true });
    // agencyData
    try {
      await addCredit(creditData, agencyId);
      set({ isError: false, error: null });
      let agencyData = useAgencyStore.getState().agencyData
      if (agencyData.length === 0 ) {
        await useAgencyStore.getState().getAgencies()
        agencyData = useAgencyStore.getState().agencyData
      }
      const agencyName = agencyData.find(a => a.id === agencyId)?.name
      await useCreditStore.getState().getCredit(agencyName!); 
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
      set({ error: errorMessage, isError: true });
    } finally {
      set({ isLoading: false });
    }
  },

  getCredit: async (agencyName:string) => {
    set({ isLoading: true });

    try {
      const response: GetCreditResponse = await fetchCredit( agencyName);

      set({isError: false, error: null, getCreditData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  getCreditReports: async (agencyName:string, type:TransactionTypes, page:number,pageSize:number) => {
    set({ isLoading: true });

    try {
      const response: GetCreditReportsResponse = await fetchCreditReports( agencyName,type,page,pageSize);

      set({isError: false, error: null, getCreditReportsData: response });

    } catch (error) {
        set({ error: 'Failed to get countries', isError: true });
        throw error;
    } finally {
      set({ isLoading: false });
    }
  },


}));